<template>
  <div class="not_details">
     <div class="banner">
      <div class="w flex" style="justify-content: space-between">
        <div class="ban_l">
          <div class="tit">通知公告</div>
          <div class="desc"> 通知、资讯、新闻等校务信息宣传栏</div>
        </div>
        <div class="ban_r"></div>
      </div>
    </div>

    <div class="w tit_p">
      当前位置：<span @click="gotoIndexPage">首页</span>
      <img src="../../assets/icon/icon-right.png" alt="" />
      <span @click="returnFn">通知公告</span>
      <img src="../../assets/icon/icon-right.png" alt="" />
      详情
    </div>

    <!-- 通知详情 -->
    <div class="w details">
      <div class="title">{{noticeInfo.title}}</div>
      <div class="origin flex">
        <div class="flex">
          <div style="margin-right:20px;">来源：{{noticeInfo.departmentName}}</div>
          <div>日期：{{noticeInfo.time}}</div>
        </div>
        <div  class="flex">
            <div>字体：</div>
            <div :class="['size',index==sizeClass?'size_cls':'']" v-for="(item,index) in size" :key="index" @click="changeSize(index)">{{item}}</div>
        </div>
      </div>
      <div class="content" :style="sizeClass==1?'font-size: 16px;':sizeClass==0?'font-size: 18px;':'font-size: 14px;'" v-html="noticeInfo.content"></div>
    </div>

  </div>
</template>

<script>
import {findNoticeByIdApi} from '@/api/index'
import { format } from '../../../utils/utils';
export default {
  data() {
    return {
     noticeInfo:{},
      size:["大","中","小"],
      id:0,
      sizeClass:2,
    };
  },
  created() {
    // console.log(this.$route.query);
    this.id = this.$route.query.noticeId;
    // 获取详情
    findNoticeByIdApi(this.id).then(res => {
      // console.log(res);
      res.time=format(res.createTime,'yyyy-MM-dd')
      this.noticeInfo = res;
    }).catch(err => {
        this.$message.error(err.message)
      })
  },
  mounted() {

  },
  methods: {    
    changeSize(idx){
      this.sizeClass = idx;
    },
    gotoIndexPage(){
      this.$router.push('/');
    },
    returnFn(){
      // let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      // let idx = '';
      // naviTop.forEach((item,index) => {
      //   if(item.link == '/notice'){
      //     idx = index
      //   }
      // });
      this.$router.push('/notice?')
    },
  },
};
</script>

<style scoped lang="less">
.not_details{
  .banner {
    width: 100%;
    height: 17rem;
    background: url("../../assets/banner-color.png") no-repeat center;
    background-size: cover;
    text-align: left;
    margin-bottom: 28px;
    .ban_l {
      flex: 1;
      .tit {
        font-weight: 900;
        font-size: 40px;
        margin-bottom: 1%;
      }
      .desc {
        font-size: 18px;
        color: #7a8ba4;
      }
    }
    .ban_r {
      width: 43%;
      height: 272px;
      background: url("../../assets/banner-notice.png") no-repeat right;
    }
  }
  .tit_p {
    text-align: left;
    color: #7a8ba4;
    opacity: 0.8;
    padding-bottom: 1.8rem;
    border-bottom: 1px solid #E0E5F0;
    margin-bottom: 56px;
    span{
      cursor: pointer;
    }
    img {
      margin: 0 6px 2px 8px;
    }
  }
  .title{
    font-size: 24px;
    margin-bottom: 56px; 
    text-align: center;   
  }
  .details{
    text-align: left;
  }
  .origin{
    color: #7A8BA4;
    justify-content: space-between;
    padding-bottom: 15px;
    margin-bottom: 56px;
    border-bottom: 1px solid #E0E5F0;
    .size{
      margin-left: 12px;
      padding: 2px 10px;
      border: 1px solid #E0E5F0;
      border-radius: 4px;   
      cursor: pointer;   
    }
    .size_cls{
      border: 1px solid var(--themeColor);
      color: var(--themeColor);
    }
  }
  .content{
    padding-bottom: 54px;
    border-bottom: 1px solid #E0E5F0;
    margin-bottom: 79px;

  }
}
</style>
